import React, { useMemo, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import HeaderDescription from "../../../../components/commons/HeaderDescription";
import ImageView from "../../../../components/commons/ImageView";
import { Edit } from "@material-ui/icons";
import EditSingleDocModal from "../modals/EditSingleDocModal";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import { toastMessage } from "../../../../helpers/toastMessage";
import mobioApi from "../../../../services";
import ExpireUpdateModel from "../modals/ExpireUpdateModel";

const safeJsonParse = (data) => {
  try {
    if (typeof data === "object" && data !== null) {
      // Already parsed
      return data;
    }

    if (typeof data === "string") {
      let parsed = data;

      // Keep parsing while it's a valid JSON string
      while (typeof parsed === "string") {
        try {
          parsed = JSON.parse(parsed);
        } catch {
          break;
        }
      }

      return parsed && typeof parsed === "object" ? parsed : {};
    }

    return {};
  } catch {
    return {};
  }
};

const OtherDocumentsInfo = ({ onboardingData, token }) => {
  const networkDocs = onboardingData?.network?.networkDocs || [];
  const onboardingDocs = onboardingData?.onboardingDocs || [];
  const [docEditModal, setDocEditModel] = useState(false);
  const [expireEditModal, setExpireEditModel] = useState(false);
  const [docEditData, setDocEditData] = useState(null);

  const mergedDocs = useMemo(() => {
    const order = ["Text", "Pattern", "Image", "File"];

    return networkDocs
      .map((doc) => {
        const existing = onboardingDocs.find((d) => d.networkDocId === doc.id);
        // const parsedData = safeJsonParse(existing?.data || "{}");
        const parsedData = existing?.data;
        const onboardingDocId = existing?.id;

        return {
          ...doc,
          existingData: parsedData,
          onboardingDocId: onboardingDocId,
        };
      })
      .sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type))
      .filter((doc) => !doc.isDeleted);
  }, [networkDocs, onboardingDocs]);

  const initialValues = useMemo(() => {
    return mergedDocs.reduce((acc, doc) => {
      if (doc.type === "Image" || doc.type === "File") {
        // acc[doc.name] =
        //   safeJsonParse(doc.existingData || "{}")?.image ||
        //   safeJsonParse(doc.existingData || "{}")?.front ||
        //   "";
        acc[doc.name] = doc.existingData;
      } else if (doc.type === "Text" || doc.type === "Pattern") {
        acc[doc.name] = safeJsonParse(doc.existingData || "{}")?.value || "";
        // acc[doc.name] = doc.existingData;
      } else {
        acc[doc.name] = doc.existingData;
      }

      return acc;
    }, {});
  }, [mergedDocs]);

  console.log("mergedDocs", mergedDocs);

  return (
    <div className="">
      <div className="width-full ">
        {mergedDocs?.filter((mf) => ["Text", "Pattern"].includes(mf.type))
          ?.length > 0 && (
          <div className="bg-white border-radius-8 px-28 pb-40 pt-24">
            <Formik
              enableReinitialize
              initialValues={initialValues}
              onSubmit={async (values, { setSubmitting, setErrors }) => {
                try {
                  const fieldData = mergedDocs?.filter((mf) =>
                    ["Text", "Pattern"].includes(mf.type)
                  );

                  let formErrors = {};

                  // validation checking

                  fieldData?.forEach((field) => {
                    const fieldName = field.name;
                    const userValue = values[fieldName];

                    // 1. Required (Mandatory)
                    if (field.mandatory && !userValue) {
                      formErrors[fieldName] = `${fieldName} is required`;
                      return;
                    }

                    // 2. Pattern Check
                    if (userValue && field.pattern) {
                      const parsedPattern = safeJsonParse(field.pattern);
                      const regex = new RegExp(parsedPattern.value);

                      if (!regex.test(userValue)) {
                        formErrors[
                          fieldName
                        ] = `${fieldName} does not match required pattern`;
                      }
                    }
                  });

                  // If any errors → block submission
                  if (Object.keys(formErrors).length > 0) {
                    setErrors(formErrors);
                    toastMessage(
                      "error",
                      "Please correct the highlighted fields"
                    );
                    setSubmitting(false);
                    return;
                  }

                  const payload = fieldData?.map((field) => {
                    const fieldName = field.name;
                    const userValue = values[fieldName];
                    const oldExistingData = safeJsonParse(field.existingData);
                    return {
                      networkDocId: field?.id,
                      onboardingDocId: field?.onboardingDocId,
                      existingData: {
                        ...oldExistingData,
                        value: userValue,
                      },
                    };
                  });

                  const api = mobioApi(token);
                  const response = await api.onboardingDocFieldInfoUpdate({
                    docField: payload,
                  });
                  if (response?.data?.success) {
                    onboardingData.onboardingDocs =
                      onboardingData?.onboardingDocs?.map((doc) => {
                        const updateData = payload?.filter(
                          (updateData) => updateData.onboardingDocId === doc.id
                        );
                        if (updateData?.length > 0) {
                          doc.data = JSON.stringify(updateData[0].existingData);
                        }

                        return doc;
                      });
                    toastMessage(
                      "success",
                      response?.data?.msg || "User data update successfully"
                    );
                  }
                } catch (error) {
                  toastMessage("error", error?.response?.data.msg);
                } finally {
                  setSubmitting(false);
                }
              }}
            >
              {({ setFieldValue, isSubmitting }) => (
                <Form className="">
                  <HeaderDescription
                    heading="Other Information"
                    description="In here all the documents detail."
                  />

                  <div className="mt-20">
                    {/* field printing */}
                    <div className="grid-two">
                      {mergedDocs
                        ?.filter((mf) => ["Text", "Pattern"].includes(mf.type))
                        ?.map((doc, index) => {
                          const { id, name, type, mandatory, existingData } =
                            doc;
                          const fieldName = name;
                          const existingDataConvert =
                            safeJsonParse(existingData);

                          // Render field based on type
                          const renderField = () => {
                            // TEXT / PATTERN
                            if (type === "Text" || type === "Pattern") {
                              return (
                                <div className="">
                                  <div className="input-field-md-lg" key={id}>
                                    <label>
                                      {name}{" "}
                                      {mandatory && (
                                        <span className="onboarding-custom-required">
                                          *
                                        </span>
                                      )}
                                    </label>
                                    <Field
                                      name={fieldName}
                                      type="text"
                                      placeholder={`Enter ${name}`}
                                      // className="onboarding-custom-input"
                                      className="type-input-focus"
                                    />
                                    <ErrorMessage
                                      name={fieldName}
                                      component="p"
                                      className="onboarding-custom-error"
                                    />
                                  </div>
                                </div>
                              );
                            }

                            // return null;
                          };

                          return <div>{renderField()}</div>;
                        })}
                    </div>
                  </div>

                  <div className="flex align-item-center justify-content-end mt-42">
                    <MOButtonV2
                      type="submit"
                      text="UPDATE DATA"
                      textColor="#ffffff"
                      radius={4}
                      widthSize={200}
                      height={42}
                      padding={"10px 12px 10px 12px"}
                      backgroundColor="#29AEE6"
                      fontSize={12}
                      disabled={isSubmitting}
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        )}

        <section className="bg-white border-radius-8 px-28 pb-40 pt-24 mt-20">
          <HeaderDescription
            heading="File and Documents"
            description="In here all the documents detail."
          />
          {/* image and file printing */}
          {/* <div className="onboarding-custom-row"> */}
          <div className="grid-two mt-20">
            {mergedDocs
              ?.filter((mf) => ["Image", "File"].includes(mf.type))
              ?.map((doc, index) => {
                const { id, name, type, mandatory, existingData } = doc;
                const fieldName = name;
                const existingDataConvert = safeJsonParse(existingData);

                // Render image and file
                const renderImageField = () => {
                  // IMAGE
                  if (type === "Image" && !existingDataConvert?.file) {
                    return (
                      <div>
                        <div className="onboarding-custom-field mt-16" key={id}>
                          <label className="onboarding-custom-label">
                            {name}{" "}
                            {mandatory && (
                              <span className="onboarding-custom-required">
                                *
                              </span>
                            )}
                          </label>

                          {existingDataConvert ? (
                            <div>
                              <div className="onboarding-custom-image-wrapper mt-8">
                                {Object.entries(existingDataConvert)
                                  .filter(([key]) =>
                                    ["front", "back", "side", "image"].includes(
                                      key
                                    )
                                  )
                                  .map(([key, url]) => (
                                    <div
                                      key={key}
                                      className="onboarding-custom-image-box pos-relative "
                                    >
                                      <Edit
                                        style={{
                                          backgroundColor: "#29AEE6",
                                          padding: "2px",
                                          borderRadius: "50%",
                                          color: "#ffffff",
                                          position: "absolute",
                                          top: "-11px",
                                          right: "6px",
                                          fontSize: 18,
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setDocEditData({
                                            doc: doc,
                                            replacement: key,
                                          });
                                          setDocEditModel(true);
                                        }}
                                      />
                                      <ImageView src={url} />
                                      {/* <img
                                    src={url}
                                    alt={`${name} ${key}`}
                                    className="onboarding-custom-image"
                                  /> */}
                                      <p className="onboarding-custom-image-text">
                                        {key}
                                      </p>
                                    </div>
                                  ))}
                              </div>
                              {existingDataConvert?.expiry && (
                                <>
                                  <p
                                    onClick={() => {
                                      setExpireEditModel(true);
                                      setDocEditData({
                                        doc: doc,
                                        replacement: "expiry",
                                      });
                                    }}
                                    className="name-badge mt-12 cursor-pointer "
                                    style={{
                                      width: "max-content",
                                    }}
                                  >
                                    Expiry:{" "}
                                    {new Date(
                                      existingDataConvert?.expiry
                                    ).toLocaleDateString("en-CA")}
                                  </p>
                                </>
                              )}
                            </div>
                          ) : (
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                // if (file) setFieldValue(fieldName, file);
                              }}
                              className="onboarding-custom-input-file"
                            />
                          )}
                        </div>
                      </div>
                    );
                  }

                  // FILE

                  if (
                    (type === "Image" || type === "File") &&
                    existingDataConvert?.file
                  ) {
                    const hasExistingFile = existingDataConvert?.file;

                    return (
                      <div>
                        <div className="onboarding-custom-field" key={id}>
                          <label className="onboarding-custom-label">
                            {name}{" "}
                            {mandatory && (
                              <span className="onboarding-custom-required">
                                *
                              </span>
                            )}
                          </label>

                          {hasExistingFile ? (
                            <div className="flex gap-12">
                              <a
                                href={existingDataConvert.file}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  display: "inline-block",
                                  padding: "8px 12px 6px 12px",
                                  color: "#000",
                                  backgroundColor: "#29aee6",
                                  color: "#ffffff",
                                  borderRadius: "4px",
                                  textDecoration: "none",
                                  fontWeight: 500,
                                  fontSize: "12px",
                                  height: "36px",
                                  width: "80px",
                                  textAlign: "center",
                                }}
                              >
                                VIEW
                              </a>

                              <MOButtonV2
                                text="EDIT"
                                textColor="#ffffff"
                                radius={4}
                                widthSize={80}
                                height={36}
                                padding={"2px 12px 2px 12px"}
                                backgroundColor="#29AEE6"
                                fontSize={12}
                                onClick={() => {
                                  setDocEditData({
                                    doc: doc,
                                    replacement: "file",
                                  });
                                  setDocEditModel(true);
                                }}
                              />
                            </div>
                          ) : (
                            <input
                              type="file"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                // if (file) setFieldValue(fieldName, file);
                              }}
                              className="onboarding-custom-input-file"
                            />
                          )}
                        </div>
                      </div>
                    );
                  }

                  // return null;
                };

                return (
                  <div
                    key={id}
                    // className={`onboarding-custom-column ${
                    //   (index + 1) % 2 === 0 ? "right" : "left"
                    // }`}
                  >
                    {renderImageField()}
                  </div>
                );
              })}
          </div>
        </section>
        {docEditModal && (
          <EditSingleDocModal
            modalOpen={docEditModal}
            setModalOpen={setDocEditModel}
            token={token}
            onboardingData={onboardingData}
            docData={docEditData}
          />
        )}

        {expireEditModal && (
          <ExpireUpdateModel
            modalOpen={expireEditModal}
            setModalOpen={setExpireEditModel}
            token={token}
            onboardingData={onboardingData}
            docData={docEditData}
          />
        )}
      </div>
    </div>
  );
};

export default OtherDocumentsInfo;
